import { useParams } from "react-router-dom";
import useWorkflow from "../hooks/useWorkflow";
import WorkflowSourceFieldTable from "./WorkflowSourceFieldTable";
import { InformationCircleIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { postData } from "../backend";

function PopupSourceFieldTable() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { workflow, mutateWorkflow } = useWorkflow(id);

  const [currentSignature, setCurrentSignature] = useState<number>(1);

  const [updateFileState, setUpdateFileState] = useState<"INITIAL" | "UPDATING" | "UPDATED">("INITIAL");

  async function handleUpdateFile() {
    setUpdateFileState("UPDATING");

    // TODO: Capture erros?
    for (const document of workflow!.documents)
      await postData(`/microsoft/document-config/${document!.microsoftDocumentConfig!.id}/update-file/`);

    setUpdateFileState("UPDATED");
    setTimeout(() => setUpdateFileState("INITIAL"), 2000);
  }

  if (!workflow) {
    return (
      <div className="flex flex-col items-center justify-center h-screen w-screen">
        <img src="https://static.portant.co/portant-loading-blue.svg" className="w-24 h-24" alt="Loading Logo" />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center h-screen w-screen px-2 py-4 gap-4">
      <h1 className="font-gilroy font-semibold">{workflow.name}</h1>
      <div className="relative flex flex-col gap-2 p-2 text-sm border-2 border-dashed border-blue rounded">
        <div className="flex items-center font-gilroy font-semibold">
          <InformationCircleIcon className="w-4 h-4 mr-2" />{t("How To Use The Source Field Table Window")}
        </div>
        <div className="text-xs font-semibold">
          {t("Adjust the width of the other browser window containing the document to keep this source field table window visible")}
        </div>
      </div>
      <WorkflowSourceFieldTable workflow={workflow} mutateWorkflow={mutateWorkflow} />
      {workflow.documents.filter((doc) => doc.isSignable).length > 0 &&
        <div className="flex flex-col gap-2 w-full items-start border rounded">
          <div className="bg-gray-100 p-1 text-xs font-semibold">
            To add singable fields to your document, copy and paste the placeholder images below into your document. You can adjust the size of the images to fit your needs.
          </div>
          <div className="flex gap-2 w-full px-2 text-sm">
            <button className={`w-5 h-5 border rounded flex items-center justify-center ${currentSignature === 1 ? "bg-blue-50" : "bg-white"}`} onClick={() => setCurrentSignature(1)}>
              1
            </button>
            <button className={`w-5 h-5 border rounded flex items-center justify-center ${currentSignature === 2 ? "bg-blue-50" : "bg-white"}`} onClick={() => setCurrentSignature(2)}>
              2
            </button>
            <button className={`w-5 h-5 border rounded flex items-center justify-center ${currentSignature === 3 ? "bg-blue-50" : "bg-white"}`} onClick={() => setCurrentSignature(3)}>
              3
            </button>
            <button className={`w-5 h-5 border rounded flex items-center justify-center ${currentSignature === 4 ? "bg-blue-50" : "bg-white"}`} onClick={() => setCurrentSignature(4)}>
              4
            </button>
          </div>

          <div className="flex flex-col items-start gap-2 w-full p-2">

            <img src={`https://static.portant.co/field-signature-u${currentSignature}.png`} className="h-10" alt="Signature Field" />
            <img src={`https://static.portant.co/field-initials-u${currentSignature}.png`} className="h-10" alt="Initails Field" />
            <img src={`https://static.portant.co/field-date-u${currentSignature}.png`} className="h-10" alt="Date Field" />
            <img src={`https://static.portant.co/field-text-u${currentSignature}.png`} className="h-8" alt="Text Field" />
            <img src={`https://static.portant.co/field-checkbox-u${currentSignature}.png`} className="h-5" alt="Checkbox Field" />

          </div>
        </div>
      }

      <button className={`text-xs text-white hover:text-blue mt-auto mr-auto ${updateFileState === "UPDATED" ? "" : ""} w-full`} onClick={handleUpdateFile} disabled={updateFileState === "UPDATING"}>
        {updateFileState === "INITIAL" ? "Save" : (updateFileState === "UPDATING" ? "Saving..." : "Saved!")}
      </button>

    </div>
  );
}

export default PopupSourceFieldTable;
